<template>
  <div>
    <div class="accountset1" v-if="!show">
      <div class="content">
        <div class="memberCard">会员卡配置</div>
        <div>
          <el-button
            type="primary"
            style="margin-top: 24px; font-size: 14px"
            class="el-button-auto"
            @click="newCard"
          >
            新建会员卡</el-button
          >
        </div>
        <el-row class="ginner">
          <el-col
            :span="8"
            class="cardList"
            v-for="(item, index) in formate"
            :key="index"
          >
            <div class="cardListTitle">{{ item.cardName }}</div>
            <div class="cardLisTotal">
              <p>{{ item.memberSum }}</p>
              <span>会员总数</span>
            </div>
            <div class="cardLisTotal1">
              <p>{{ item.shopSum }}</p>
              <span>
                关联店铺(家)
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Top Left 提示文字"
                  placement="top-start"
                >
                  <div slot="content">
                    <div v-for="(it, index) in item.shopList" :key="index">
                      {{ it.shopTitle }}
                    </div>
                  </div>
                  <i class="iconfont iconbangzhu2" style="font-size: 12px"></i>
                </el-tooltip>
              </span>
            </div>
            <div class="choose">
              <div @click="bonus(item.scoresCardId)">
                <img src="../../assets/images/jf/7815.svg" alt="" />
                <span>积分奖励规则</span>
              </div>
              <div @click="editCard(item.scoresCardId)">
                <img src="../../assets/images/jf/7822.svg" alt="" />
                <span>编辑</span>
              </div>
              <div @click="see(item.scoresCardId)">
                <img src="../../assets/images/jf/7818.svg" alt="" />
                <span>查看</span>
              </div>
            </div>
            <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
            <!-- <el-button
              type="text"
              style="margin-left:27px"
              class="buttonStyle"
              @click="bonus(item.scoresCardId)"
              >积分奖励规则</el-button
            > -->
            <!-- <el-button
              type="text"
              class="buttonStyle"
              style="left:199px"
              @click="editCard(item.scoresCardId)"
              >编辑</el-button
            > -->
            <!-- <el-button
              type="text"
              class="buttonStyle"
              style="left:296px"
              @click="see(item.scoresCardId)"
              >查看</el-button
            > -->
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 新建会员卡弹框 -->
    <el-dialog
      title="新建会员卡"
      :visible.sync="details"
      width="480px"
      :before-close="handleClose"
    >
      <div style="margin-bottom: 12px">
        <span>&nbsp;&nbsp;&nbsp;&nbsp;会员卡名称：</span>
        <span class="posiable"
          ><el-input
            style="width: 310px"
            :maxlength="10"
            v-model="cardNameNum"
            show-word-limit
          ></el-input>
        </span>
      </div>
      <span slot="footer" style="padding-right: 2px">
        <el-button @click="details = false" style="width: 90px">取消</el-button>
        <el-button type="primary" style="width: 90px" @click="preserve"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <!-- 新建会员卡 -->
    <card-edit
      v-if="show == 2"
      @transformAnalysis="transformAnalysis"
      @editCard="editCard"
      :formate="formate"
      :newData="newData"
      :index="index"
      :pastId="pastId"
    ></card-edit>
    <!-- 积分奖励规则 -->
    <bonus-points
      v-if="show == 3"
      :bonusId="bonusId"
      @transformAnalysis="transformAnalysis"
    ></bonus-points>
    <!-- 查看会员卡 -->
    <look-card
      v-if="show == 4"
      :seeId="seeId"
      @transformAnalysis="transformAnalysis"
      :dataList="data"
      :tommerNum="dataNum"
    ></look-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
import cardEdit from "./prop/card_edit";
import bonusPoints from "./prop/bonus_points";
import lookCard from "./prop/look_card";

import {
  list,
  getDetailById,
  getChangeYesterday,
  gradeList,
  create,
} from "@/api/manage/scoreList";
export default {
  name: "union_card",
  components: {
    cardEdit,
    bonusPoints,
    lookCard,
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  data() {
    return {
      formate: [],
      show: "",
      data: [], //查看会员卡
      app: "",
      dataNum: {}, //昨日数据接口
      shopIdDate: [], //获取店铺Id和平台来源
      pastId: "",
      seeId: "", //查看带过去的id
      details: false, //新建会员卡弹窗
      cardNameNum: "",
      newData: {},
      //  pastName:""
    };
  },
  created() {
    this.buriedPoint(1, "忠诚度管理", "忠诚度管理", "会员卡配置");
  },
  mounted() {
    this.list();
    // return
    if (this.$route.query.flag == 1) {
      console.log(this.$route.query.pastId);
      this.editCard(this.$route.query.pastId);
    }
  },
  methods: {
    //卡片接口
    list() {
      list([])
        .then((res) => {
          if (res.code == 200) {
            this.formate = res.data;
          }
        })
        .catch((err) => {});
    },
    //查看
    see(id) {
      this.show = 4;
      this.seeId = id;
      getDetailById({ cardId: id })
        .then((res) => {
          if (res.code == 200) {
            this.data = res.data;
          }
          getChangeYesterday({ cardId: id })
            .then((res) => {
              if (res.code == 200) {
                this.dataNum = res.data;
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    //跳转新建会员卡
    newCard() {
      this.details = true;
      this.cardNameNum = "";
    },
    //保存
    preserve() {
      this.index = 2;
      this.details = false;
      create({ cardName: this.cardNameNum }).then((res) => {
        this.show = 2;
        this.newData = res.data;
      });
    },
    handleClose() {
      this.details = false;
    },
    //返回上一层列表
    transformAnalysis() {
      this.show = "";
      this.list();
    },
    //跳转积分奖励规则
    bonus(id) {
      this.show = 3;
      this.bonusId = id;
    },
    //编辑
    editCard(id) {
      this.index = 1;
      this.pastId = id;
      console.log(this.pastId);
      this.show = 2;
    },
  },
};
</script>
<style lang="scss" scope>
/deep/ .flootClass .el-dialog__footer {
}
.footerStyle {
  text-align: right;
  margin-top: 30px;
}
.length {
  position: relative;
  left: -50px;
}
.accountset1 {
  .global-comment {
    margin-top: 15px;
  }
  .content {
    box-sizing: border-box;
    padding: 18px 30px 40px;
    background: rgba(255, 255, 255, 1);
    // border: 1px solid rgba(230, 230, 230, 1);
    box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
    border-radius: 6px;
    // padding-bottom: 100px;
    .memberCard {
      width: 90px;
      height: 25px;
      font-size: 18px;
      font-weight: bold;
      line-height: 21px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    .ginner {
      width: calc(100% + 15px);
    }
    .cardList {
      margin-top: 20px;
      padding: 20px;
      padding-bottom: 10px;
      width: 388px;
      height: 210px;
      border: 1px solid #b1c9e6;
      background-image: url("../../assets/images/jf/5401.png");
      opacity: 1;
      border-radius: 12px;
      display: inline-block;
      position: relative;
      margin-right: 15px;
      box-sizing: border-box;
      .cardListTitle {
        position: absolute;
        top: 20px;
        height: 28px;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        color: #333333;
        opacity: 1;
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .cardLisTotal {
        position: absolute;
        top: 68px;
        // left:98px;
        height: 20px;
        font-weight: 400;
        line-height: 28px;
        color: #333333;
        opacity: 1;
        p {
          min-width: 70px;
          height: 29px;
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          opacity: 1;
          margin: 0px;
        }
        span {
          color: #999999;
          font-size: 12px;
        }
      }
      .cardLisTotal1 {
        position: absolute;
        top: 68px;
        left: 98px;
        height: 20px;
        font-weight: 400;
        line-height: 28px;
        color: #333333;
        opacity: 1;
        p {
          min-width: 70px;
          height: 29px;
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          opacity: 1;
          margin: 0px;
        }
        span {
          color: #999999;
          font-size: 12px;
        }
      }
      .choose {
        border-top: 2px dashed rgba(54, 109, 179, 0.2);
        margin-top: 119px;
        display: flex;
        // background: #333;
        width: 100%;
        height: 50px;
        // text-align: center;
        cursor: pointer;
        div {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          // border: 1px solid red;

          img {
            // display: block;
            // margin-left: 47px;
            // margin-top: 16px;
            margin-top: 10px;
            width: 20px;
            height: 20px;
          }
          span {
            // display: block;
            // width: 84px;
            // height: 20px;
            font-size: 14px;
            margin-top: 4px;
            color: #366db3;
          }
        }
      }
      .publicNum {
        width: 19px !important;
        height: 22px !important;
        font-size: 16px !important;
        font-weight: bold !important;
        line-height: 28px !important;
        color: #333333 !important;
        opacity: 1 !important;
      }
      .buttonStyle {
        position: absolute;
        bottom: 13px;
        font-size: 14px;
        color: #fff;
      }
      .buttonStyle:hover {
        color: #f5f5f5;
      }
    }
    @media screen and(max-width:1440px) {
      .ginner {
        width: calc(100% + 20px);
      }
      .cardList {
        margin-top: 20px;
        padding: 15px;
        padding-bottom: 10px;
        padding-top: 10px;
        width: 310px;
        height: 168px;
        border: 1px solid #b1c9e6;
        background-image: url("../../assets/images/jf/5401.png");
        background-size: 310px 168px;
        opacity: 1;
        border-radius: 16px;
        display: inline-block;
        position: relative;
        margin-right: 20px;
        box-sizing: border-box;
        .cardListTitle {
          position: absolute;
          top: 15px;
          height: 28px;
          width: 260px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 20px;
          font-weight: 600;
          line-height: 28px;
          // font-family: PingFang SC;
          color: #333333;
          opacity: 1;
        }
        .cardLisTotal {
          position: absolute;
          top: 48px;
          // left:98px;
          height: 20px;
          font-family: DIN;
          font-weight: 400;
          line-height: 28px;
          color: #333333;
          opacity: 1;
          p {
            min-width: 70px;
            height: 24px;
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            opacity: 1;
            margin: 0px;
          }
          span {
            color: #999999;
            font-size: 12px;
          }
        }
        .cardLisTotal1 {
          position: absolute;
          top: 48px;
          left: 83px;
          height: 20px;
          font-family: DIN;
          font-weight: 400;
          line-height: 28px;
          color: #333333;
          opacity: 1;
          p {
            min-width: 70px;
            height: 24px;
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            opacity: 1;
            margin: 0px;
          }
          span {
            color: #999999;
            font-size: 12px;
          }
        }
        .choose {
          border-top: 2px dashed rgba(54, 109, 179, 0.2);
          margin-top: 88px;
          display: flex;
          // background: #333;
          width: 100%;
          height: 50px;
          // text-align: center;
          // border: 1px solid red;
          cursor: pointer;
          @media screen and (max-width: 1440px) {
            border-top: 1.7px dashed rgba(54, 109, 179, 0.2);
            margin-top: 96px;
          }
          div {
            flex: 1;
            display: flex;

            img {
              display: block;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              width: 16px;
              height: 16px;
            }
            span {
              display: block;
              // width: 84px;
              // height: 20px;
              font-size: 12px;
              margin-top: 4px;
              color: #366db3;
            }
          }
        }
        .publicNum {
          width: 19px !important;
          height: 22px !important;
          font-size: 16px !important;
          font-weight: bold !important;
          line-height: 28px !important;
          color: #333333 !important;
          opacity: 1 !important;
        }
        .buttonStyle {
          position: absolute;
          bottom: 13px;
          font-size: 14px;
          color: #fff;
        }
        .buttonStyle:hover {
          color: #f5f5f5;
        }
      }
      .cardList:nth-child(3n) {
        margin-right: 0px;
      }
      // .cardList:last-child {
      //   margin-right: 0px;
      // }
    }
    @media screen and(max-width:1279px) {
      .cardList:nth-child(3n) {
        margin-right: 20px;
      }
    }
  }
}
</style>
